import client from '@/graphql/client'
import CreateOrganisation from '@/graphql/mutations/CreateOrganisation'
import DeleteOrganisation from '@/graphql/mutations/DeleteOrganisation'
import ListOrganisations from '@/graphql/queries/ListOrganisations'

export const organisations = {
  namespaced: true,
  state: {
    organisations: null
  },
  mutations: {
    setOrganisations (state, payload) {
      state.organisations = payload
    },
    addOrUpdateOrganisation (state, payload) {
      const index = state.organisations?.findIndex((organisation) => organisation.id === payload.id)
      if (index >= 0) {
        state.organisations[index] = Object.assign(state.organisations[index], payload)
      } else {
        if (!state.organisations) { state.organisations = [] }
        state.organisations.push(payload)
      }
    },
    deleteOrganisation (state, payload) {
      const index = state.organisations.findIndex((organisation) => organisation.id === payload.id)
      if (index >= 0) {
        state.organisations.splice(index, 1)
      }
    }
  },
  actions: {
    async createOrganisation ({ commit }, { name }) {
      try {
        const { createOrganisation } = await client.query({
          operationName: 'createOrganisation',
          query: CreateOrganisation,
          variables: {
            name
          }
        })
        commit('addOrUpdateOrganisation', createOrganisation)
        commit('snackbar/showMessage', { content: 'Created' }, { root: true })
        return createOrganisation.id
      } catch (e) {
        console.log(e)
      }
    },

    async updateOrganisation ({ commit, dispatch }, { name, id }) {
      try {
        const { createOrganisation } = await client.query({
          operationName: 'createOrganisation',
          query: CreateOrganisation,
          variables: {
            id,
            name
          }
        })
        commit('addOrUpdateOrganisation', createOrganisation)
        commit('snackbar/showMessage', { content: 'Updated' }, { root: true })
        // update project names in projectMemberships
        await dispatch('projectMemberships/listProjectMembershipsForCurrentUser', null, { root: true })
        return createOrganisation.id
      } catch (e) {
        console.log(e)
      }
    },

    async deleteOrganisation ({ commit }, { id }) {
      try {
        const { deleteOrganisation } = await client.query({
          operationName: 'deleteOrganisation',
          query: DeleteOrganisation,
          variables: {
            id
          }
        })
        commit('deleteOrganisation', deleteOrganisation)
        commit('snackbar/showMessage', { content: 'Deleted' }, { root: true })
      } catch (e) {
        alert(e.message)
        console.log(e)
      }
    },

    async listOrganisations ({ commit }) {
      const { listOrganisations } = await client.query({
        operationName: 'listOrganisations',
        query: ListOrganisations
      })
      commit('setOrganisations', listOrganisations)
    }
  }
}
